export default "__VITE_ASSET__hyYtt5Oe__"